import { Pipe, PipeTransform } from '@angular/core';

import { Group } from '@libs/src/models/group.model';
import {
  accountFieldOptions,
  groupFieldOptions,
} from '@main-client/src/app/attribute-mapping/attribute-mapping.helper';

@Pipe({
  name: 'appCsvAttributeTranslationName',
})
export class CsvAttributeTranslationNamePipe implements PipeTransform {
  transform(value: string, group: Group): string {
    const accountFieldValue = accountFieldOptions.find(
      (field) => value === field.value,
    );
    if (accountFieldValue) {
      return accountFieldValue.label;
    }
    const groupField = groupFieldOptions.find((field) => value === field.value);
    if (groupField) {
      return groupField.label;
    }
    return [...group.custom_segments, ...group.hidden_custom_segments].find(
      (segment) => value === segment._id,
    )?.title;
  }
}
